import styled from '@emotion/styled';
import type { ViewState } from 'react-map-gl';
import type { Track } from './Layers/TrackLayer';

export const SmallContainer = styled.div`
  width: 300px;
  height: 300px;
`;

export const BigContainer = styled.div`
  width: 100%;
  height: calc(100vh - 30px);
`;

export const dresdenViewport: ViewState = {
  latitude: 51.051749,
  longitude: 13.741525,
  zoom: 12,
  bearing: 0,
  pitch: 0,
  padding: {
    right: 30,
    left: 30,
    top: 30,
    bottom: 30,
  },
};

export const exampleTracks: Array<Track> = [
  [
    [13.735, 51.048],
    [13.74, 51.05],
    [13.75, 51.06],
  ],
  [
    [13.738, 51.05],
    [13.745, 51.04],
    [13.747, 51.048],
  ],
];

export const examplePoints = [
  [13.735, 51.048],
  [13.74, 51.05],
  [13.75, 51.06],
];
